export const PURCHASE_TABS = {
  all: 'all',
  purchased: 'purchased',
  subscription: 'subscription',
  assigned: 'assigned',
}

export const getPurchaseTabs = ({ subscription = false, assigned = false } = {}) => {
  const tabs = [{ id: PURCHASE_TABS.all, title: 'All' }]

  if (subscription) {
    tabs.push({ id: PURCHASE_TABS.purchased, title: 'Purchased' })
    tabs.push({ id: PURCHASE_TABS.subscription, title: 'Subscription' })
  }

  if (assigned) {
    tabs.push({ id: PURCHASE_TABS.assigned, title: 'Assigned items' })
  }

  return tabs
}

export const defaultSubscriptionFilters = {
  query: '',
  page: 1,
}

const subscriptionHeaders = [{
  value: 'product', title: 'Product', sortable: false, centered: false,
}, {
  value: 'price', title: 'Price', sortable: false, centered: false,
}, {
  value: 'rate', title: 'Rate', sortable: false, centered: false,
}, {
  value: 'actions', title: 'Actions', sortable: false, centered: false,
}]

const subscriptionColgroup = ['50%', '10%', '15%', '25%']

export const defaultSubscriptionTable = {
  className: 'products-list',
  select: false,
  rows: [],
  colgroup: subscriptionColgroup,
  headers: subscriptionHeaders,
}
